import { takeLatest, put, call } from "redux-saga/effects";
import * as types from "src/types/actions";
import callApi from "./helpers";
import { apiGraphQLURI } from "src/env";

const getConfig = (params, query, method = "POST") => {
  let config = {
    mode: "cors",
    headers: {
      Authorization: `Bearer ${params.payload.token}`,
    },
    method: method,
  };

  if (method === "POST") {
    config = {
      ...config,
      headers: {
        ...config.headers,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(query),
    };
  }

  return config;
};

export function* getRentals(params) {
  const query = {
    query: `{
      Rental{
        rental_agreement_number
        confirmation_number
        pickup{
          location
          dateTime
        }
        dropoff{
          location
          dateTime
        }
        first_name
        last_name
        brand
        country
        reservation_number
        vehicle{
          registration_number
          vehicle_class
          vehicle_number
        }
        pre_rental_photo
        pre_rental_photos
        damage
        damage_data{
          vir
          damage_photos_locations
        }
        rental_agreement
        rental_invoice
        rental_photos {
          batch_id
          batch_type
          batch_date
          photo_urls
          comments
          coordinates{
            latitude
            longitude
          }
        }
        tolls
        ev_charges
        infringements
        signed_rental_agreement
        signed_rental_agreements
        insurance_rider
        instant_return
        gold_number
        esignature_trace {
          documents {
            url
          }
        }
        virs {
            reportStatus
            status
            reportNumber
            damagePhotos {
                customer
                staff
            }
            thirdPartyDetails {
                lastName
            }
            thirdParty
            otherDriverDetails {
                lastName
            }
            incidentDetails {
                date
                description
                address
                renterDriving
            }
            virStatus
            incidentReports
            assessmentReports
            damageDetails {
                batchId
                damageCodes {
                    name
                    description
                    id
                    type
                }
            }
            date
        } 
      }
    }`,
  };
  try {
    yield call(callApi, () => fetch(apiGraphQLURI, getConfig(params, query)), types.GETRENTALS);
  } catch (error) {
    yield put({ type: types.GETRENTALS_FAILURE, error: error });
  }
}

export function* updateRentalPhotos(params) {
  const { raNumber, batchId, imageType, comments } = params.payload;
  const query = {
    query: `
    mutation updateRentalPhotos {
      Rental (
        customer_photos: {
          rental_agreement_number: "${raNumber}"
          batch_id: "${batchId}"
          batch_type: ${imageType}
          comments: "${comments || ""}"
        }
      ) {
        rental_agreement_number
        rental_photos {
          batch_id
          batch_type
          batch_date
          photo_urls
          comments
          coordinates{
            latitude
            longitude
          }
        }
      }
    }
  `,
  };
  try {
    yield call(callApi, () => fetch(apiGraphQLURI, getConfig(params, query)), types.UPDATE_PHOTOS);
  } catch (error) {
    yield put({ type: types.UPDATE_PHOTOS_FAILURE, error });
  }
}

export function* refreshRentalPhotos(params) {
  const query = {
    query: `
    mutation refershRentalPhotos {
      Rental (
        customer_photos: {
          check_new_damage_photos: true
        }
      ) {
        rental_agreement_number
        pre_rental_photos
        rental_photos {
          batch_id
          batch_type
          batch_date
          photo_urls
          comments
          coordinates{
            latitude
            longitude
          }
        }
      }
    }
  `,
  };
  try {
    yield call(callApi, () => fetch(apiGraphQLURI, getConfig(params, query)), types.REFRESH_PHOTOS);
  } catch (error) {
    yield put({ type: types.REFRESH_PHOTOS_FAILURE, error });
  }
}

export function* watchRentalRequest() {
  yield takeLatest(types.GETRENTALS, getRentals);
  yield takeLatest(types.UPDATE_PHOTOS, updateRentalPhotos);
  yield takeLatest(types.REFRESH_PHOTOS, refreshRentalPhotos);
}
